import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import BuildStack from "./pages/BuildStack";
import Subscriptions from "./pages/Subscriptions";
import Pickup, { PickupLocationDetail } from "./pages/Pickup";
import CartPage from "./pages/CartPage";
import OrderConfirmation from "./pages/OrderConfirmation";
import AuthPage from "./pages/AuthPage";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import Partner from "./pages/Partner";
import EmailPreferences from "./pages/EmailPreferences";
import { OurStory, Ingredients, Faq, Contact, GymPartners, PolicyPage, NotFound } from "./pages/Info";
import JournalHub from "./pages/JournalHub";
import JournalArticle from "./pages/JournalArticle";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/build-your-stack" element={<BuildStack />} />
                <Route path="/subscriptions" element={<Subscriptions />} />
                <Route path="/pickup" element={<Pickup />} />
                <Route path="/pickup/:slug" element={<PickupLocationDetail />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/order-confirmation" element={<OrderConfirmation />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/account" element={<Account />} />
                <Route path="/account/subscriptions/:id" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/partner" element={<Partner />} />
                <Route path="/email-preferences" element={<EmailPreferences />} />
                <Route path="/our-story" element={<OurStory />} />
                <Route path="/ingredients" element={<Ingredients />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/gym-partners" element={<GymPartners />} />
                <Route path="/journal" element={<JournalHub />} />
                <Route path="/journal/:slug" element={<JournalArticle />} />
                <Route path="/privacy" element={<PolicyPage kind="privacy" />} />
                <Route path="/terms" element={<PolicyPage kind="terms" />} />
                <Route path="/refund-policy" element={<PolicyPage kind="refund" />} />
                <Route path="/subscription-policy" element={<PolicyPage kind="subscription" />} />
                <Route path="/accessibility" element={<PolicyPage kind="accessibility" />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
